import { PathWithId } from "@constellation-academy/epic-ui";
import { MessageDispatchEditPath } from "../message-dispatch-edit/message-dispatch-edit.paths";

export class MessageDispatchesPath extends PathWithId<typeof MessageDispatchesPath> {
	static readonly pathKey = "messagesDispatches";
	static readonly pathName = "messages-dispatches";
	static readonly idKey = "messageDispatchId";
	static readonly childPaths = [MessageDispatchEditPath];
}
